<div nxRow *ngIf="maInsurance">
    <div nxCol="12">
        <div *ngFor="let coverage of maInsurance.coverages">

            <nx-accordion variant="extra-light">
                <nx-expansion-panel>

                    <nx-expansion-panel-header #header>
                        <nx-expansion-panel-title>
                            <ng-container [ngTemplateOutlet]="iconWithName"
                                [ngTemplateOutletContext]="{insuredPersons: coverage.insuredPersons}"></ng-container>
                            <nx-link *ngIf="!header.isExpanded()">{{ 'ma-insurance.life.showMore' | translate }}</nx-link>
                            <nx-link *ngIf="header.isExpanded()">{{ 'ma-insurance.life.hideDetails' | translate }}</nx-link>
                        </nx-expansion-panel-title>
                    </nx-expansion-panel-header>

                    <div *ngFor="let insurance of coverage.insurances" class="nx-margin-bottom-l coverage-detail">
                        <ng-container [ngSwitch]="insurance.extend.detailTypeIdentifier">
                            <app-life01-ins *ngSwitchCase="'life01Ins'"
                                [maInsuranceExtend]="insurance.extend"></app-life01-ins>
                            <app-life02-ins-rsk *ngSwitchCase="'life02InsRsk'"
                                [maInsuranceExtend]="insurance.extend"></app-life02-ins-rsk>
                            <app-life03-ins-rsk-veh *ngSwitchCase="'life03InsRskVeh'"
                                [maInsuranceExtend]="insurance.extend"></app-life03-ins-rsk-veh>
                            <app-life04-ins-rsk-redir *ngSwitchCase="'life04InsInvRskRedir'"
                                [maInsuranceExtend]="insurance.extend"></app-life04-ins-rsk-redir>
                            <app-life05-ins-annuity *ngSwitchCase="'life05InsAnnuity'"
                                [maInsuranceExtend]="insurance.extend"></app-life05-ins-annuity>
                            <app-life06-ins-deposit *ngSwitchCase="'life06InsDeposit'"
                                [maInsuranceExtend]="insurance.extend"></app-life06-ins-deposit>
                            <app-life07-ins-household-liab *ngSwitchCase="'life07InsHouseholdLiab'"
                                [maInsuranceExtend]="insurance.extend" [agent]="agent"></app-life07-ins-household-liab>
                            <app-life08-ins-pmp *ngSwitchCase="'life08InsPmp'"
                                [maInsuranceExtend]="insurance.extend"></app-life08-ins-pmp>
                        </ng-container>
                    </div>

                </nx-expansion-panel>
            </nx-accordion>
        </div>
    </div>
</div>

<ng-template #iconWithName let-insuredPersons="insuredPersons">
    <span>
        <ng-container [ngSwitch]="hasManyInsuredPersons(insuredPersons)">
            <cpc-icon *ngSwitchCase="true" icon="users-o" [color]="'#006192'"></cpc-icon>
            <cpc-icon *ngSwitchDefault icon="user-o" [color]="'#006192'"></cpc-icon>
        </ng-container>
        <div class="insured-persons">
            <span *ngFor="let insuredPerson of insuredPersons">
                {{ insuredPerson.name }}, {{ insuredPerson.birthDate|dateFormat }}
            </span>
        </div>
    </span>
</ng-template>